var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"category"},[_c('h4',{staticClass:"category-title"},[_vm._v("Название категории")]),_c('ul',{staticClass:"category-list"},_vm._l((_vm.categories),function(category){return _c('li',{key:category.name,staticClass:"category-item"},[_c('CategoryItem',{attrs:{"category":category}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }